export class UseCase {
}
export class QueryUseCase {
}
